export enum ProcedureStepCompletionStatus {
	INCOMPLETE = 0,
	FAILED = 1,
	COMPLETE = 2,
}

export enum ProcedureStepActivityTimelineItemType {
	FIELD_VALUES = "FIELD_VALUES",
	COMMENT = "COMMENT",
	EVENT = "EVENT",
	REVIEW = "REVIEW",
}
